declare global {
  interface Number {
    formatDistance(): string;
    formatFileSize(): string;
    formatDuration(): string;
    formatCount(one: string, many: string): string;
  }
}

Number.prototype.formatDistance = function (this: number) {
  return this >= 1
    ? this.toFixed(2) + ' M'
    : (this * 100).toFixed(1) + ' CM';
};

Number.prototype.formatFileSize = function (this: number) {
  if (this === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(this) / Math.log(k));
  return (this / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i];
};

/**
 * Seconds as an administrator reads them, the one way every page of the panel writes a length of
 * time: whole days as days, otherwise hours and minutes, and under an hour the seconds too.
 * `7 d`, `8 h`, `1 h 30 min`, `15 min`, `1 min 20 s`, `45 s`; the server words its offline credit
 * messages the same way.
 *
 * **Never more than the amount, and never nothing for an amount above nothing.** Each part is cut,
 * never rounded up: 80 seconds used to read "1 min" beside 60, 90 seconds "2 min", and 59 min 59 s
 * "1 h". Under an hour the seconds are shown rather than dropped, and an amount under a second
 * says so rather than reading "0 s". Above an hour the seconds are left off, which can only make
 * an amount read a little less than it is.
 *
 * A number and its unit are joined by a no-break space, so a narrow screen never leaves the unit
 * alone on the next line.
 */
const NBSP = ' ';

Number.prototype.formatDuration = function (this: number) {
  if (!(this > 0)) return '0';
  if (this % 86400 === 0) return `${this / 86400}${NBSP}d`;
  if (this < 1) return `under 1${NBSP}s`;
  if (this < 60) return `${Math.floor(this)}${NBSP}s`;

  if (this < 3600) {
    const minutes = Math.floor(this / 60);
    const seconds = Math.floor(this % 60);

    return seconds ? `${minutes}${NBSP}min ${seconds}${NBSP}s` : `${minutes}${NBSP}min`;
  }

  const hours = Math.floor(this / 3600);
  const minutes = Math.floor((this % 3600) / 60);

  return minutes ? `${hours}${NBSP}h ${minutes}${NBSP}min` : `${hours}${NBSP}h`;
};

/**
 * A count with its noun, singular for exactly one: `1 seat`, `0 seats`, `2 seats`. Every count the
 * panel writes in words goes through here, so none reads "1 seats" or "event(s)".
 */
Number.prototype.formatCount = function (this: number, one: string, many: string) {
  return `${this} ${this === 1 ? one : many}`;
};

export { };
